// ITEM

export const OVERVIEW_FIELD_NAMES = [
  'id',
  'name',
  'code',
  'responsible_person',
  'stock_locations_breadcrumb',
  'remote_repository',
]
export const OWNERSHIP_LIFECYCLE_FIELD_NAMES = [
  'owner',
  'owned_by',
  'created',
  'created_by',
  'modified',
  'modified_by',
  'is_frozen',
  'freeze_date',
  'deleted',
  'deleted_by',
  'deleted_date',
]

// FieldGrid-compatible 2D layout for ownership/lifecycle fields
export const OWNERSHIP_LIFECYCLE_GRID = [
  ['owner', 'owned_by'],
  ['created', 'created_by'],
  ['modified', 'modified_by'],
  ['is_frozen', 'freeze_date'],
  ['deleted', null],
  ['deleted_by', 'deleted_date'],
]
export const REQUIRED_ANNOTATIONS_FIELD_NAMES = ['required_annotations']
export const CONTRIBUTORS_FIELD_NAMES = ['contributors']
export const PERMISSIONS_FIELD_NAMES = ['permissions']

export const NON_CLONABLE_FIELD_NAMES = [
  'id',
  'owner',
  'owned_by',
  'responsible_person',
  'stock_locations',
  'stock_locations_breadcrumb',
  'deleted',
  'deleted_by',
  'deleted_date',
  'permissions',
]

export const NON_CLONABLE_ASSAY_FIELD_NAMES = ['state', 'flowcell']
export const NON_CLONABLE_SAMPLE_FIELD_NAMES = ['type']

export const FROZEN_EDITABLE_FIELD_NAMES = ['project', 'permissions']

// STATUS
export const ARCHIVE_STATUS_COLOR_MAP = {
  failure: 'danger',
  initialized: 'link',
  inprogress: 'link',
  onhold: 'grey',
  success: 'success',
}

export const ASSAY_STATE_STATUS_COLOR_MAP = {
  incoming: 'grey',
  initialized: 'link',
  new: 'link',
  registered: 'success',
  template: 'info',
}

export const SAMPLE_STATE_STATUS_COLOR_MAP = {
  planned: 'info',
  created: 'success',
  new: 'link',
}

export const COLLECTION_STATUS_COLOR_MAP = {
  available: 'success',
  not_available: 'danger',
}

export const DATA_STATUS_COLOR_MAP = {
  error: 'danger',
  new: 'link',
  online: 'success',
  offline: 'grey',
  success: 'success',
}

export const EXPERIMENT_STATUS_COLOR_MAP = {
  completed: 'success',
  failed: 'danger',
  'in progress': 'link',
  planned: 'grey',
}

export const ORDEREDITEM_STATUS_COLOR_MAP = {
  pending: 'warning',
  received: 'success',
  ordered: 'link',
  cancelled: 'danger',
}

export const VOCABULARY_STATUS_COLOR_MAP = {
  active: 'success',
  inactive: 'grey',
}

// WF
// Workflow data types
export const WORKFLOW_DATATYPES = [
  { value: 'MAIN', label: 'Main' },
  { value: 'CONFIG', label: 'Config' },
  { value: 'LOG', label: 'Log' },
  { value: 'PARAMETER', label: 'Parameter' },
  { value: 'INPUT', label: 'Input' },
  { value: 'TEST', label: 'Test' },
  { value: 'OUTPUT', label: 'Output' },
  { value: 'OTHER', label: 'Other' },
  { value: 'DAG_PNG', label: 'DAG PNG' },
  { value: 'README', label: 'README' },
  { value: 'LICENSE', label: 'License' },
]

//
export const VIEWABLE_MIME_TYPES = [
  'audio/aac',
  'video/x-msvideo',
  'image/bmp',
  'text/css',
  'text/csv',
  'image/gif',
  'text/html',
  'image/jpeg',
  'application/pdf',
  'application/json',
  'application/ld+json',
  'text/markdown',
  'audio/midi',
  'audio/x-midi',
  'audio/mpeg',
  'video/mp4',
  'video/mpeg',
  'video/quicktime',
  'audio/ogg',
  'video/ogg',
  'audio/ogg',
  'image/png',
  'image/svg+xml',
  'text/plain',
  'audio/wav',
  'audio/webm',
  'video/webm',
  'application/manifest+json',
  'image/webp',
  'application/xhtml+xml',
  'application/xml',
  'text/xml',
]

// Size cap for the in-memory (text-sheet) preview types — text/JSON/CSV/MD/…
// read whole into memory. Streamed media and browser-native docs (PDF/XML/HTML,
// rendered straight from the URL) are not capped.
export const MAX_PREVIEW_SIZE = 50 * 1024 * 1024
